import { IS, NORMALIZE, editable_IS, isEditable, isEmptyEditable } from "./likables";

export const S_NORMALIZE_int = (_: string) => !isEmptyEditable(_) && isEditable(_) && editable_IS.int(_) ? NORMALIZE.int(_) as string : _;
export const S_NORMALIZE_dec = (_: string) => !isEmptyEditable(_) && isEditable(_) && IS.decimal(5)(_) ? NORMALIZE.decimal(_) as unknown as string : _;
